@if (showbilling()) {
  <billing-summary [visible]="showbilling()"  [planSummarydata]="planSummary$()" 
   [isCartFlow]="isCartFlow()" [billedAtTenantId]="billedAtTenantId()"
    (closeSidePopup)="CloseBillingSummary($event)" (addToCart)="AddToCart($event)" />
}

@if (showPosBilling()) {
  <pos-billing-summary [visible]="showPosBilling()"  [posSummaryData]="planSummary$()"
   [isCartFlow]="isCartFlow()" [billedAtTenantId]="billedAtTenantId()" [billedForTenantId]="billedForTenantId()" (addToCart)="AddToCart($event)"
    (closeSidePopup)="CloseBillingSummary($event)" />
}


@if (showPaymentStatusSidebar$) {
  <payment-status-timeline [visible]="showPaymentStatusSidebar$"  [uuid]="uuid" [linkType]="linkType()"
    (hidePaymentSummaryPopup)="HidePaymentSummary($event)" (GoToClientSubscription)="GoToClientDetails($event)"
    [ispayment]="ispayment" [skipPaymentPolling]="skipPaymentPolling" />
}
